import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../components/ui/Button';
import ActivityRow from './ActivityRow';

const RecentActivityTable = ({ activities, loading }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-sm">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between p-4 md:p-6 border-b border-border">
        <h2 className="text-lg md:text-xl font-semibold text-foreground">{t('dashboard.recentActivity')}</h2>
        <div className="flex flex-wrap items-center gap-2">
          <Button
            variant="outline"
            onClick={() => navigate('/alerts')}
            iconName="ArrowRight"
            iconPosition="right"
          >
            {t('dashboard.viewAllAlerts')}
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate('/candidates-list')}
            iconName="ArrowRight"
            iconPosition="right"
          >
            {t('dashboard.viewAllCandidates')}
          </Button>
        </div>
      </div>

      {loading ? (
        <div className="p-8 flex items-center justify-center">
          <div className="flex items-center gap-3">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-primary" />
            <span className="text-sm text-muted-foreground">{t('dashboard.loadingActivity')}</span>
          </div>
        </div>
      ) : activities?.length === 0 ? (
        <div className="p-8 text-center">
          <p className="text-muted-foreground">{t('dashboard.noActivity')}</p>
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-muted/50">
              <tr>
                <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  {t('dashboard.tableCandidate')}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider">
                  {t('dashboard.tableActivity')}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                  {t('dashboard.tableType')}
                </th>
                <th className="px-4 py-3 text-left text-xs font-medium text-muted-foreground uppercase tracking-wider whitespace-nowrap">
                  {t('dashboard.tableTime')}
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {activities.map((activity) => (
                <ActivityRow key={activity.id} activity={activity} />
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default RecentActivityTable;
